import { render, staticRenderFns } from "./product-branch.view.vue?vue&type=template&id=2ab3bd40&scoped=true&lang=pug"
import script from "./product-branch.view.vue?vue&type=script&lang=ts"
export * from "./product-branch.view.vue?vue&type=script&lang=ts"
import style0 from "./product-branch.view.vue?vue&type=style&index=0&id=2ab3bd40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab3bd40",
  null
  
)

export default component.exports